import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { LayoutTemplate, TrendingUp, Award, FileText, ShieldCheck, MessageSquare, Check } from 'lucide-react';
const features = [{
  icon: LayoutTemplate,
  text: 'Estructura Eficiente'
}, {
  icon: TrendingUp,
  text: 'Flujos de Cierre'
}, {
  icon: Award,
  text: 'Estrategias de Valor'
}, {
  icon: FileText,
  text: 'Plantillas Listas'
}, {
  icon: ShieldCheck,
  text: 'Blindaje Legal'
}, {
  icon: MessageSquare,
  text: 'Técnicas de Venta'
}];
const skills = ['Creación de Presupuestos Profesionales', 'Gestión de la Visita de Diagnóstico', 'Estrategia de Venta de 3 Niveles', 'Seguimiento No Invasivo por WhatsApp', 'Cotización In Situ de Acabados y Pintura', 'Redacción de Cláusulas Comerciales Inamovibles', 'Manejo de Objeciones de Precio', 'Cierre de Contratos en la Primera Reunión'];
export function SystemOverview() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-brand-dark text-white" data-id="element-211">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="text-center mb-10 sm:mb-16" data-id="element-213">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-brand-accent mb-6 sm:mb-8" data-id="element-214">
            EL SISTEMA N°1 EN ARGENTINA
          </h2>

          {/* Soluciones Ya logo @ 400% */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex justify-center my-6 sm:my-10" data-id="element-215">
            <img src="https://cdn.magicpatterns.com/uploads/wqYy4Qok5E79f4cHbNMY1W/solucionesya.png" alt="Soluciones Ya — Tienda oficial" loading="lazy" decoding="async" width="320" height="320" className="w-[72px] h-[72px] sm:w-24 sm:h-24 md:w-[120px] md:h-[120px] object-contain drop-shadow-2xl pt-[10px] pb-[10px] pl-[10px] pr-[10px]" data-id="element-216" />
          </motion.div>

          <p className="text-base sm:text-xl text-gray-300 font-medium" data-id="element-217">
            Sistema completo · 6 Tomos + 3 Bonos · Herramientas Profesionales ·
            Todo resuelto.
          </p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-3 gap-2 sm:gap-4 md:gap-8 mb-10 sm:mb-16" data-id="element-218">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="bg-white/5 border border-white/10 rounded-xl p-3 sm:p-6 text-center hover:bg-white/10 transition-colors flex flex-col items-center justify-center" data-id="element-219">
                <Icon className="w-6 h-6 sm:w-10 sm:h-10 text-brand-accent mb-2 sm:mb-4" data-id="element-220" />
                <h3 className="font-bold text-xs sm:text-lg leading-tight" data-id="element-221">
                  {feature.text}
                </h3>
              </motion.div>;
        })}
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 sm:p-8 md:p-12" data-id="element-222">
          <div className="text-center mb-6 sm:mb-10" data-id="element-223">
            <p className="text-lg sm:text-2xl font-bold text-white mb-2" data-id="element-224">
              Funciona desde hoy en tu oficina, estudio o directamente parado en
              la obra del cliente.
            </p>
            <p className="text-brand-accent font-medium uppercase tracking-wider text-xs sm:text-sm" data-id="element-225">
              Habilidades de negocio incluidas:
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-3 sm:gap-y-4" data-id="element-226">
            {skills.map((skill, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="flex items-center bg-white/5 sm:bg-transparent p-3 sm:p-0 rounded-lg sm:rounded-none" data-id="element-227">
                <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-green-500/20 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-228">
                  <Check className="w-3 h-3 sm:w-4 sm:h-4 text-green-400" data-id="element-229" />
                </div>
                <span className="text-sm sm:text-base text-gray-200 font-medium" data-id="element-230">
                  {skill}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}